// API proposte lato Operatore Economico (art. 193).
// Wrappa useHttp di Veda; tutte le chiamate usano il prefisso /api/v1/operatore
// e la company/operatore sono sempre risolte dalla sessione lato backend.
import { useHttp } from '@veda/dashboard-ui';

const BASE = '/api/v1/operatore';

export function usePropostaApi() {
  const { request, loading } = useHttp();

  const get  = (url, cb) => request(url, { method: 'GET', ...cb });
  const post = (url, data, cb) => request(url, { method: 'POST', body: JSON.stringify(data), ...cb });
  const put  = (url, data, cb) => request(url, { method: 'PUT', body: JSON.stringify(data), ...cb });
  const del  = (url, cb) => request(url, { method: 'DELETE', ...cb });

  return {
    loading,

    // Procedimenti su cui è possibile presentare una proposta
    procedimentiAperti: (cb) => get(`${BASE}/procedimenti-aperti`, cb),

    // Proposte della propria company
    listProposte: (cb) => get(`${BASE}/proposte`, cb),
    getProposta:  (id, cb) => get(`${BASE}/proposte/${id}`, cb),

    // Crea bozza su un procedimento
    creaBozza: (procedimentoId, data, cb) =>
      post(`${BASE}/procedimenti/${procedimentoId}/proposte`, data, cb),

    // Salvataggio bozza per step
    aggiornaBozza: (id, data, cb) => put(`${BASE}/proposte/${id}`, data, cb),

    eliminaProposta: (id, cb) => del(`${BASE}/proposte/${id}`, cb),

    // Avanzamento (sola lettura) + cronologia
    avanzamento: (id, cb) => get(`${BASE}/proposte/${id}/avanzamento`, cb),

    // Integrazioni documentali (Fase 10)
    listIntegrazioni: (id, cb) => get(`${BASE}/proposte/${id}/integrazioni`, cb),
    uploadDocumentoIntegrazione: (id, richiestaId, formData, cb) =>
      request(`${BASE}/proposte/${id}/integrazioni/${richiestaId}/documenti`, {
        method: 'POST', body: formData, type: 'file_upload', ...cb,
      }),
    rispondiIntegrazione: (id, richiestaId, data, cb) =>
      post(`${BASE}/proposte/${id}/integrazioni/${richiestaId}/rispondi`, data, cb),

    // Completezza requisiti art. 193
    completezza: (id, cb) => get(`${BASE}/proposte/${id}/completezza`, cb),

    // Invio (Bozza → Ricevuta)
    presenta: (id, cb) => post(`${BASE}/proposte/${id}/presenta`, {}, cb),

    // Documenti allegati
    listDocumenti: (id, cb) => get(`${BASE}/proposte/${id}/documenti`, cb),
    uploadDocumento: (id, formData, cb) =>
      request(`${BASE}/proposte/${id}/documenti`, {
        method: 'POST', body: formData, type: 'file_upload', ...cb,
      }),
    aggiornaDocumento: (id, documentoId, data, cb) =>
      request(`${BASE}/proposte/${id}/documenti/${documentoId}`, {
        method: 'PATCH', body: JSON.stringify(data), ...cb,
      }),
    eliminaDocumento: (id, documentoId, cb) =>
      del(`${BASE}/proposte/${id}/documenti/${documentoId}`, cb),
    scaricaDocumento: (id, documentoId) =>
      `${BASE}/proposte/${id}/documenti/${documentoId}/download`,

    downloadAttoProvvedimento: (id, nomeFile, callbacks) =>
      request(`${BASE}/proposte/${id}/provvedimento/atto/download`, {
        method: 'GET',
        download: true,
        onSuccess: async (response) => {
          const blob = await response.blob();
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = nomeFile;
          a.click();
          URL.revokeObjectURL(url);
          callbacks?.onSuccess?.();
        },
        onError: callbacks?.onError,
        onFormError: callbacks?.onFormError,
      }),
  };
}
